angular.module('angus.directives').directive('terms', [
	'actionViewTemplates',
	function(actionViewTemplates) {
		'use strict';

		return {
			templateUrl: actionViewTemplates.terms,
		};
	}
]);